import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { ViewportScroller, DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
